import React from 'react';
import PromptModal from '../../components/Modals/PromptModal';

interface EventPlaceConflictModalProps {
  isOpen: boolean;
  currentPlace?: string;
  eventPlace?: string;
  type: 'eventToPlace' | 'placeToEvent';
  onCancel: () => void;
  onUpdatePlace: () => void;
  onKeepEventPlace?: () => void;
  onRemoveEvent?: () => void;
}

const EventPlaceConflictModal: React.FC<EventPlaceConflictModalProps> = ({
  isOpen,
  currentPlace,
  eventPlace,
  type,
  onCancel,
  onUpdatePlace,
  onKeepEventPlace,
  onRemoveEvent,
}) => {
  if (type === 'eventToPlace') {
    // When selecting an event with a different place than currently selected
    return (
      <PromptModal
        buttonWidth="fit-content"
        title="Location Mismatch"
        description={
          <>
            This event is not at {currentPlace}.<br />
            Use event location of <b>{eventPlace}</b> instead?
          </>
        }
        declineText="Cancel"
        acceptText="Add Event & Update Place"
        declineCallback={onCancel}
        acceptCallback={onUpdatePlace}
        isOpen={isOpen}
      />
    );
  } else {
    // When changing place but an event is selected with a different place
    return (
      <PromptModal
        buttonWidth="fit-content"
        title="Location Mismatch"
        description={
          <>
            Event not at <b>{currentPlace}</b>.<br />
            Keep event location of {eventPlace} instead, or use <b>{currentPlace}</b> and remove the
            event?
          </>
        }
        declineText="Cancel"
        acceptText="Add Place & Remove Event"
        declineCallback={onKeepEventPlace}
        acceptCallback={onRemoveEvent}
        isOpen={isOpen}
      />
    );
  }
};

export default EventPlaceConflictModal;
